module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/puff-1ec7b0b0532c7a4b83b61148c811fab5.jpg";